import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutTopbar: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLayoutTopbar"><Path d="M3 3H21V9L3 9V3Z" fill="currentColor"/><Path d="M3 10.5V21L11.25 21V10.5L3 10.5Z" fill="currentColor"/><Path d="M12.75 21L21 21V10.5L12.75 10.5V21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutTopbar;
